module.exports = __webpack_public_path__ + "img/fbr-logo-black.1f8f123c.png";